import { CreatePlaidLinkTokenRequest, ExchangePlaidTokenRequest, PayableKey, PaymentMethodClient, PaymentMethodResponse } from "Services/API/API";
import { useApiClient } from "Services/API/useApiClient";
import { useCallback, useEffect, useState } from "react";
import { PlaidLinkOptions, usePlaidLink } from "react-plaid-link";

export interface UseBankAccountProps {
   payableKey: PayableKey,
   onSuccess?: (response: PaymentMethodResponse) => void,
   onError?: (error: unknown) => void
   onExit?: () => void,
}

function useBankAccount({ payableKey, onSuccess, onError, onExit }: UseBankAccountProps) {
   const [token, setToken] = useState<string | null>(null);
   
   const paymentMethodClient = useApiClient(PaymentMethodClient);
   
   const onPlaidLinkSuccess = useCallback(async (token, metadata) => {
      try {
         const response = await paymentMethodClient.exchangePlaidToken(ExchangePlaidTokenRequest.fromJS({
            publicToken: token,
            accountId: metadata.account_id,
            payableKey: payableKey
         }))
         if(response.success)
         {
            if(onSuccess)
               onSuccess(response);
         }
         else if(onError)
         {
            onError(response);
         }
      }
      catch(ex) {
         if(onError)
            onError(ex);
      }
  }, [payableKey]);

   const plaidConfig: PlaidLinkOptions = {
      token: token,
      //onLoad: onPlaidLinkLoad,
      onSuccess: onPlaidLinkSuccess,
      onExit: onExit,      
   };

   //This is not documented feature of plaid. Ideally it should be configured in dashboard
   //See https://github.com/plaid/quickstart/issues/36
   (plaidConfig as any).selectAccount = true;

   const plaidLinkMethods = usePlaidLink(plaidConfig);

   useEffect(() => {
      const createLinkToken = async () => {
         const link_token = await paymentMethodClient.createLinkToken(new CreatePlaidLinkTokenRequest({
            payableKey: payableKey
         }));
         setToken(link_token);
       };
       createLinkToken();
   }, [])

   return plaidLinkMethods;
}

export default useBankAccount;